import React, { useMemo } from 'react';

// DEPENDENCIES
import { compose } from 'redux';
import { connect } from 'react-redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// MAIN COMPONENT
const EmailSettingsList = compose(connect(({ dealership, user }) => ({ dealership, user })))(
  ({ dealership, user: { stores } }) => {
    // MEMOS
    const dealerLable = useMemo(
      () => stores.filter(store => store?.make_dealer_id === dealership).map(store => store?.dealer_name),
      [dealership, stores]
    );

    return (
      <Main>
        <Title title={`Email Settings: ${dealerLable}`} />
        <Table mobilePreviewKeys={['dealer_email_setting_type_name', 'is_active']} />
      </Main>
    );
  }
);

// EXPORT
export default getListData(EmailSettingsList, {
  key: 'emailSettings',
  path: makePath(INTERFACE.settings, SETTINGS.emailSettings),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.emailSettings.list
  },
  columns: [
    {
      key: 'dealer_email_setting_type_name',
      label: 'Template Name',
      mobileLabel: 'Template'
    },
    {
      key: 'dealer_email_setting_type_description',
      label: 'Description',
      width: 200
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active email settings will generate the email broadcast on the indicated event.'
    }
  ],
  actions: [ACTIONS.edit('dealer_email_setting_id')]
});
